import ConnectStoreStore from './ConnectStoreStore'

export default ConnectStoreStore
